import { ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import 'react-phone-number-input/style.css';
import { createContext, useContext, useMemo } from 'react';
import { NotificationInstance } from 'antd/es/notification/interface';
import useNotification from 'antd/es/notification/useNotification';
import Alert from './components/Alert';
import Router from './router';

interface AppContextHandler {
  globalNotif?: NotificationInstance;
}

export const AppContext = createContext<AppContextHandler>({});

export const useAppContext = () => useContext(AppContext);

function App() {
  const [globalNotif, notifContext] = useNotification();
  const value = useMemo(() => ({ globalNotif }), [globalNotif]);
  return (
    <AppContext.Provider value={value}>
      {notifContext}
      <ConfigProvider theme={{ token: { colorPrimary: '#843549' } }}>
        <HelmetProvider>
          <Router />
          <Alert />
        </HelmetProvider>
      </ConfigProvider>
    </AppContext.Provider>
  );
}

export default App;
